import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Immutable from 'immutable'
import config from 'config/api'
import Spinner from 'components/UI/Spinner';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import {Redirect} from 'react-router-dom'
import {withRouter} from 'react-router-dom'
import clsx from 'clsx'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Stu from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {withStyles, useStyles} from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import notifyParentWindowOfSizeChange from 'helpers/notifyParentWindowOfSizeChange'

const QUIZ = {
  questions: [
    {
      label: 'Triglycéridémie à jeun > 10 mmol/L 3 fois consécutives*',
      points: '5',
      type: 'tf'
    }, {
      label: 'Triglycéridémie à jeun > 20 mmol/L au moins une fois',
      points: '1',
      type: 'tf'
    }, {
      label: 'Antécédent de triglycéridémie à jeun < 2 mmol/L',
      points: '-5',
      type: 'tf'
    }, {
      label: 'Absence de cause secondaire** (sauf grossesse*** et éthinylestradiol)',
      points: '2',
      type: 'tf'
    }, {
      label: 'Antécédent de pancréatite',
      points: '1',
      type: 'tf'
    }, {
      label: 'Douleur abdominale récurrente inexpliquée',
      points: '1',
      type: 'tf'
    }, {
      label: 'Absence d\'antécédent familial d\'hyperlipidémie combinée',
      points: '1',
      type: 'tf'
    }, {
      label: 'Pas de réponse (baisse des TG < 20 %) à un traitement hypolipidémiant',
      points: '1',
      type: 'tf'
    }, {
      label: 'Survenue des symptômes à :',
      points: [
        '0', '1', '2', '3'
      ],
      type: 's',
      options: ['> 40 ans', '< 40 ans', '< 20 ans', '< 10 ans',]
    }
  ],
  profiles: [
    {
      condition: '<',
      threshold: '8',
      label: 'SHCF très peu probable',
      color: 'green'
    }, {
      condition: '=',
      threshold: '8',
      label: 'SHCF peu probable',
      color: 'green'
    }, {
      condition: '=',
      threshold: '9',
      label: 'SHCF possible',
      color: 'orange'
    }, {
      condition: '>=',
      threshold: '10',
      label: 'SHCF très probable',
      color: 'red'
    }
  ]
};
const Q = Immutable.fromJS(QUIZ);

const styles = (theme) => {
  // console.log(theme.palette)
  return {
    root: {
      maxWidth: 800,
      margin: '0 auto',
      textAlign: 'left',
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      minHeight: 20,
      // marginBottom: 20,
      '&:nth-of-type(2)': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    headerMain: {
      borderBottom: '6px '+theme.palette.primary.main+' solid',
      marginBottom: 20,
    },
    headerLarge: {
      backgroundColor: theme.palette.secondary.main,
      minHeight: 20,
      marginBottom: 0,
      padding: '5px 10px',
    },
    headerSmall: {
      minHeight: 10,
    },
    headerTitle: {
      fontSize: '1.5em',
      color: '#fff',
      padding: '5px 18px'
    },
    mainContent: {
      padding: '0 20px'
    },
    footer: {
      backgroundColor: theme.palette.secondary.main,
      height: 20,
      marginTop: 20
    },
    h1: {
      fontSize: '2em'
    },
    h2: {
      fontSize: '1em',
      marginBottom: 20
    },
    profileScore: {
      color: theme.palette.text.secondary,
      fontSize: '2em'
    },
    caption: {
      color: theme.palette.text.secondary,
      marginBottom: 20,
      display: 'block'
    },
    row: {
      borderBottom: '2px solid ' + theme.palette.secondary.main,
      borderLeft: '2px solid ' + theme.palette.secondary.main,
      borderRight: '2px solid ' + theme.palette.secondary.main,
      '&:nth-of-type(1)': {
        borderTop: '2px solid ' + theme.palette.secondary.main
      }
    },
    formLabel: {
      padding: '12px 10px',
      // minHeight: '100%',
      // minHeight: 32,
      // paddingTop: 12,
      // lineHeight: 48 + 'px',
      color: theme.palette.secondary.main
      // height: 48,
      // lineHeight: 48,
      // display: 'flex',
      // flexGrow: 1
    },
    formChoice: {
      // display: 'flex',
      minHeight: 48,
      lineHeight: 48 + 'px',
      backgroundColor: '#fdefe2',
      // color: theme.palette.secondary.main,
      justifyContent: 'space-around',
      // borderLeft: '2px solid ' + theme.palette.secondary.main
    },
    formRadio: {
      marginRight: 3
    },
    formRadioLabel: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold'
    },
    formRadioIcon: {
      color: theme.palette.secondary.main
    },
    formRadioIconChecked: {
      color: theme.palette.primary.main
    },
    formControl: {
      backgroundColor: 'transparent'
    },
    formSelect: {
      backgroundColor: '#fdefe2',
      height: 48,
      padding: 0
    },
    formSelectIcon: {
      stroke: theme.palette.secondary.main
    },
    formSelectItem: {
      color: theme.palette.secondary.main,
      lineHeight: 48 + 'px',
      paddingLeft: 30,
    },
    formSelectItemSelected: {
      lineHeight: 48 + 'px',
      paddingLeft: 30,
      color: theme.palette.primary.main,
      '&:focus, &:hover, &:active': {
        backgroundColor: '#fdefe2',
        borderBottom: 'none'
      }
    },
    rightColumnHeader: {
      textAlign: 'center',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      padding: '10px 0',
      fontSize: '1.2em',
      borderTop: '2px solid ' + theme.palette.secondary.main,
      borderLeft: '2px solid ' + theme.palette.secondary.main,
      borderRight: '2px solid ' + theme.palette.secondary.main
    },
    formSubmit: {
      display: 'block',
      margin: '0 auto'
    },
    logError: {
      color: 'red',
      fontSize: '1.4em'
    },
    green: {
      color: theme.palette.success.main
    },
    orange: {
      color: theme.palette.warning.main
    },
    red: {
      color: theme.palette.error.main
    },
    gutterBottom: {
      marginBottom: 20
    },
    clickable: {
      cursor: 'pointer'
    }
  }
}
function StyledRadio(props) {
  return (<Radio color="primary" {...props}/>);
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props}/>;
}

function toInt(i) {
  return parseInt(i, 10)
}
class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 'intro'
      // logError: false,
      // logSuccess: false,
      // totalScore: 0,
      // showResults: false
    };
    // const qk = Q.get('questions').size;
    // let i;
    // for (i = 0; i < qk; i++) {
    //   this.state['q' + i] = undefined;
    // }
    this._compute = this._compute.bind(this);
    this._reset = this._reset.bind(this);
    this._onRadioChange = this._onRadioChange.bind(this);
    this._onSelectChange = this._onSelectChange.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
  }
  componentDidMount() {
    this._reset(() => {
      notifyParentWindowOfSizeChange();
    });
  }

  componentDidUpdate(oldProps) {
    // console.log(oldProps)
    // if (oldProps.classes === undefined && this.props.classes !== undefined) {
    //   console.log('OK')
    // }

  }
  _nextPage() {
    this.setState({page: 'scoring'}, () => {
      notifyParentWindowOfSizeChange();
      // setTimeout(() => {window.scrollTo(0,0)}, 100)
      // document.body.scrollTo(0,0)
      window.scrollTo(0,0)
    })
  }
  _previousPage() {
    this.setState({page: 'intro'}, () => {
      notifyParentWindowOfSizeChange();
      // setTimeout(() => {window.scrollTo(0,0)}, 100)
      // document.body.scrollTo(0,0)
      window.scrollTo(0,0)
    })
  }
  _reset(callback) {
    const qk = Q.get('questions').size;
    let i;
    var nState = {
      logError: false,
      logSuccess: false,
      totalScore: 0,
      showResults: false,
      profile: false
      // totalScore: 9,
      // showResults: true,
      // profile: 1
    };
    for (i = 0; i < qk; i++) {
      nState['q' + i] = '';
    }
    this.setState(nState, () => {
      if (callback && typeof(callback) === 'function') callback();
    });
  }

  _compute() {
    const qk = Q.get('questions').size;
    let i;
    let passed = true;
    let answers = [],
    answer,
    qt;
    let totalScore = 0;
    // this.setState({submitDisabled: true});
    for (i = 0; i < qk; i++) {
      answer = this.state['q' + i];
      passed = answer !== undefined && answer !== '' && answer !== false
      ? passed
      : false;
      if (passed === true) {
        // console.log(Q.get('questions').toJS(), i)
        qt = Q.get('questions').get(i).get('type');
        if (qt === 'tf') {
          totalScore = answer === 'yes'
          ? totalScore + toInt(Q.get('questions').get(i).get('points'))
          : totalScore;
        } else if (qt === 's') {
          totalScore = totalScore + toInt(Q.get('questions').get(i).get('points').get(answer))
        }
      }
    }
    if (!passed) {
      const clearError = () => {
        setTimeout(() => this.setState({logError: false}), 2500)
      };
      this.setState({
        // submitDisabled: false,
        logError: 'Merci de répondre à toutes les questions'
      }, clearError);
      return;
    } else {
      const $$profiles = Q.get('profiles');
      const pk = $$profiles.size;

      let profile = false,
      condition,
      threshold;
      for (i = 0; i < pk; i++) {
        condition = $$profiles.get(i).get('condition');
        threshold = $$profiles.get(i).get('threshold');
        // console.log({condition, threshold, totalScore})
        if (profile === false && condition === '<' && totalScore < threshold) {
          profile = i;
        } else if (profile === false && condition === '<=' && totalScore <= threshold) {
          profile = i;
        } else if (profile === false && condition === '=' && totalScore == threshold) {
          profile = i;
        } else if (profile === false && condition === '>=' && totalScore >= threshold) {
          profile = i;
        }
      }
      this.setState({totalScore, showResults: true, profile}, () => {
        window.scrollTo(0,window.innerHeight);
      });
    }
  }
  _onRadioChange(id, value) {
    // console.log(id, value)
    this.setState({
      ['q' + id]: value
    });
  }
  _onSelectChange(id, value) {
    // console.log(id, value)
    this.setState({
      ['q' + id]: value
    });
  }
  render() {
    const {classes} = this.props;
    const {logError, logSuccess, showResults, totalScore, profile, page} = this.state;
    return (<div className={classes.root}>
      <Choose>
        <When condition={page === 'intro'}>
          <Grid container={true} alignItems="center" justify="space-around" className={classes.headerMain}>
            <Grid item={true} xs={12} className={classes.headerLarge}>
              <Typography variant="h1" gutterBottom={true} className={classes.headerTitle}><strong>Editorial des professeurs P.&nbsp;Moulin</strong> (CHU Louis Pradel, Lyon) <strong><br/>et E.&nbsp;Bruckert</strong> (Pitié-Salpêtrière, Paris)</Typography>
            </Grid>
            <Grid item={true} xs={6} className={clsx(classes.header, classes.headerSmall)}></Grid>
            <Grid item={true} xs={6} className={clsx(classes.header, classes.headerSmall)}></Grid>
          </Grid>
          <Grid container={true} alignItems="center" justify="space-around" className={classes.mainContent}>
            <Grid item={true} xs={12}>
              <Typography variant="h1" color="secondary" className={classes.h1} gutterBottom={true}>Score FCS</Typography>
              <Typography variant="h2" className={classes.h2} gutterBottom={true}>
                <em>Moulin P </em>
                et al.
                <em>identification and diagnosis of patients with familial chylomicronaemia syndrome (FCS): Expert panel recommendations and proposal of an «FCS score». Atherosclerosis. 2018 Aug;275:265 272.</em>
              </Typography>
            </Grid>
            <Grid item={true} xs={12}>


              <Typography variant="body1" gutterBottom={true}>Le <strong>syndrome d'hyperchylomicronémie familial</strong> (<strong>SHCF</strong> - ou FCS en anglais) est une maladie génétique de transmission autosomique récessive. Elle est due à des combinaisons de mutations sur le <strong>gène de la LPL</strong> (LipoProtéine Lipase) ou bien l'un de ses cofacteurs. Cette enzyme permet l'hydrolyse des <strong>triglycérides</strong> (TG) des <strong>chylomicrons</strong>. Cette maladie est à distinguer des autres formes d'hypertriglycéridémie sévère ayant une composante polygénique avec parfois des mutations hétérozygotes. Ces syndromes d'hyperchylomicronémie multifactorielle (MCS) sont souvent sensibles aux sucres, à l'alcool et au surpoids.</Typography>

              <Typography variant="body1" gutterBottom={true}>L'absence de LPL ou sa non-fonctionnalité entraîne une <strong>accumulation de chylomicrons</strong> qui conduit à une concentration anormalement élevée des <strong>triglycérides</strong> dans le sang avec des taux dépassant <strong>10 mmol/L (8,85 g/L)</strong> et ce même malgré un régime drastique en lipides (&lt; 20 g/jour). Ces taux élevés exposent les patients atteints de SHCF à un risque élevé d'épisodes récurrents de <strong>pancréatites aiguës</strong>, générateurs <strong>d'hospitalisations</strong> et pouvant menacer le <strong>pronostic vital</strong>.</Typography>

              <Typography variant="body1" gutterBottom={true}>Le diagnostic de SHCF est généralement évoqué sur la base de l'anamnèse et d'un <strong>phénotype clinique et biologique</strong> mais la <strong>prévalence rare</strong> (1 à 2 cas pour 1 million) fait que ce syndrome est peu connu et à l'origine d'errances diagnostiques fréquentes. Le diagnostic est formel lorsqu'il est confirmé par des <strong>tests génétiques (NGS)</strong> dont l'interprétation est plus complexe que ce qui est observé dans l'hypercholestérolémie familiale.</Typography>

              <Typography variant="body1" gutterBottom={true}>Il est ainsi important d'adresser les patients qui sont susceptibles de présenter un SHCF en vue d'une exploration génétique des 5 gènes candidats impliqués. Pour aider à cela, un groupe d'experts européens a développé un <strong>algorithme</strong> basé sur un score (<strong>le FCS score</strong>), facilement réalisable en pratique, permettant de discriminer les patients avec une relative bonne sensibilité (88 %) et spécificité (85 %).</Typography>

              <Typography variant="body1" gutterBottom={true}>Il est important de bien détecter et identifier les patients afin qu'une prise en charge appropriée puisse leur être proposée. <strong>Plusieurs options thérapeutiques</strong> sont actuellement étudiées dans le SHCF : les oligonucléotides antisens (ASOs) ciblant l'apolipoprotéine C3 et l'angiopoiétine-3 ou des anticorps monoclonaux.</Typography>

              <Typography variant="body1" gutterBottom={true}>Ce « <strong>FCS score</strong> » a un double intérêt : il permet de conduire vers les <strong>tests génétiques</strong> les rares patients susceptibles de présenter un <strong>SHCF</strong> et à l'inverse de ne pas abuser inutilement de ces analyses pour des formes multifactorielles (MCS). <br />
              Pour optimiser la sensibilité, il est nécessaire de <strong>séquencer les malades ayant un score &gt; 8</strong>.</Typography>

            <Typography variant="body1" gutterBottom={true}>Enfin, ce score constitue un outil <strong>pédagogique</strong> de sensibilisation au SHCF pour des médecins qui ne connaîtraient pas ce syndrome.</Typography>

          </Grid>

          <Grid item={true} xs={12}>
            <Button color="primary" size={'large'} variant="outlined" className={classes.formSubmit} onClick={this._nextPage}>Continuer &gt;</Button>
          </Grid>
          <Grid item={true} xs={12} className={classes.footer}></Grid>

        </Grid>
      </When>
      <When condition={page === 'scoring'}>
        <Grid container={true} alignItems="center" justify="space-around" className={classes.gutterBottom}>
          <Grid item={true} xs={6} className={classes.header}></Grid>
          <Grid item={true} xs={6} className={classes.header}></Grid>
        </Grid>
        <Grid container={true} alignItems="center" justify="space-around" className={classes.mainContent}>
          <Grid item={true} xs={12}>
            <Typography variant="h1" color="secondary" className={classes.h1} gutterBottom={true}>Score FCS</Typography>
            <Typography variant="h2" className={classes.h2} gutterBottom={true}>
              <em>Moulin P </em>
              et al.
              <em>identification and diagnosis of patients with familial chylomicronaemia syndrome (FCS): Expert panel recommendations and proposal of an «FCS score». Atherosclerosis. 2018 Aug;275:265 272.</em>
            </Typography>
          </Grid>
          <Grid item={true} xs={12} sm={9}></Grid>
          <Grid item={true} xs={12} sm={3} className={classes.rightColumnHeader}>
            <If condition={showResults === false}>
              <Typography variant="h6" color="inherit">Votre choix</Typography>
            </If>
            <If condition={showResults === true}>
              <Typography variant="h6" color="inherit">Votre résultat</Typography>
            </If>
          </Grid>
        </Grid>

        <Grid container={true} alignItems="center" justify="space-around" className={classes.mainContent}>
          {
            Q.get('questions').map((q, iq) => {
              return (<Grid key={'q_' + iq} item={true} xs={12} className={classes.row}>
              <FormControl component="fieldset" fullWidth={true} variant="filled">
                <Grid container={true} spacing={0} alignItems="center" justify="space-around">
                  <Grid item={true} xs={12} sm={9}>
                    <FormLabel component="legend" className={classes.formLabel}>{q.get('label')}</FormLabel>
                  </Grid>
                  <If condition={showResults === false}>
                    <Grid item={true} xs={12} sm={3}>
                      <If condition={q.get('type') === 'tf'}>
                        <RadioGroup defaultValue={undefined} aria-label={q.get('label')} name={'radios' + iq} className={classes.formChoice} row={true} onChange={e => this._onRadioChange(iq, e.target.value)}>
                          <FormControlLabel value="yes" control={<StyledRadio classes = {{root: classes.formRadioIcon, checked: classes.formRadioIconChecked}}/>} label="Oui" classes={{
                              root: classes.formRadio,
                              label: classes.formRadioLabel
                            }}/>
                            <FormControlLabel value="no" control={<StyledRadio classes = {{root: classes.formRadioIcon, checked: classes.formRadioIconChecked}}/>} label="Non" classes={{
                                root: classes.formRadio,
                                label: classes.formRadioLabel
                              }}/>
                            </RadioGroup>
                          </If>
                          <If condition={q.get('type') === 's'}>
                            <FormControl component="fieldset" fullWidth={true} variant="filled" className={classes.formControl}>
                              <Select value={this.state['q' + iq]} onChange={e => this._onSelectChange(iq, e.target.value)} color="secondary" classes={{
                                  root: classes.formSelect,
                                  selectMenu: this.state['q' + iq] !== undefined && this.state['q' + iq] !== ''? classes.formSelectItemSelected : classes.formSelectItem,
                                  icon: classes.formSelectIcon
                                }} displayEmpty={true}>
                                <MenuItem value={''}>
                                  <em>...</em>
                                </MenuItem>
                                {
                                  q.get('options').map((o, i) => <MenuItem key={'o_' + iq + i} value={i} classes={{
                                    root: classes.formSelectItem
                                  }}>
                                  <em>{o}</em>
                                </MenuItem>).toArray()
                              }
                            </Select>
                          </FormControl>

                        </If>

                      </Grid>
                    </If>
                    <If condition={showResults === true}>
                      <Grid item={true} xs={12} sm={3}>
                        <If condition={q.get('type') == 'tf'}>
                          <Typography variant="h6" color="primary" className={classes.formChoice}>
                            {
                              (
                                this.state['q' + iq] === 'yes'
                                ? 'Oui'
                                : 'Non')
                              }&nbsp;
                              ({
                                (
                                  this.state['q' + iq] === 'yes'
                                  ? (
                                    q.get('points') >= 0
                                    ? '+' + q.get('points')
                                    : q.get('points'))
                                    : '0')
                                  })</Typography>
                                </If>
                                <If condition={q.get('type') == 's'}>
                                  <Typography variant="h6" color="primary" className={classes.formChoice}>
                                    {
                                      q.get('options').get(this.state['q' + iq])
                                    }&nbsp;
                                    ({
                                      (
                                        q.get('points').get(this.state['q' + iq]) !== undefined
                                        ? (
                                          q.get('points').get(this.state['q' + iq]) > 0
                                          ? '+' + q.get('points').get(this.state['q' + iq])
                                          : q.get('points').get(this.state['q' + iq]))
                                          : 0)
                                        })</Typography>
                                      </If>
                                    </Grid>
                                  </If>

                                </Grid>
                              </FormControl>
                            </Grid>);
                          }).toArray()
                        }
                        <Grid item={true} xs={12} style={{
                            marginTop: 10,
                            marginBottom: 20
                          }}>
                          <Typography variant={'caption'} className={classes.caption}>* Dosages séparés d'au moins un mois. Le xanthome éruptif peut être utilisé comme représentant des taux de TG élevés (rare).<br/>** Dont alcool, diabète, syndrome métabolique, hypothyroïdie, corticothérapie et autres traitements.<br/>*** Répéter le diagnostic après la grossesse le cas échéant.</Typography>
                        </Grid>
                        <Grid item={true} xs={12}>
                          <If condition={logError !== false}>
                            <Alert severity="error" style={{marginBottom: 20}}>{logError}</Alert>
                          </If>
                        </Grid>

                        <If condition={showResults !== true}>
                          <Grid item={true} xs={12}>
                            <Button color="primary" size={'large'} variant="outlined" className={classes.formSubmit} onClick={this._compute} style={{float: 'right'}}>Calculer</Button>
                            <Button color="secondary" size={'large'} variant="outlined" className={classes.formSubmit} onClick={this._previousPage} style={{float: 'left'}}>Retour</Button>


                          </Grid>
                        </If>
                        <Grid item={true} xs={12}>
                          <If condition={showResults === true}>
                            <Typography variant={'h2'} className={classes.profileScore} align="center" gutterBottom={true}>
                              Somme des points :&nbsp;
                              <strong className={classes[Q.get('profiles').get(profile).get('color')]}>{totalScore}</strong>
                            </Typography>
                            <Typography variant={'h3'} align="center" gutterBottom={true} className={classes[Q.get('profiles').get(profile).get('color')]}>
                              {Q.get('profiles').get(profile).get('label')}
                            </Typography>
                            <If condition={totalScore >= 9}>
                              <Typography variant={'h4'} align="center" gutterBottom={true} className={totalScore === 9 ? classes.orange : classes.red}>
                                Ce FCS score élevé doit motiver une prise en charge spécifique et un séquençage des gènes candidats par NGS*</Typography>
                              <Typography variant={'body1'} align="center" gutterBottom={true}>
                                <small><span className={classes.inline}>(*Next Generation Sequencing possible dans les centres suivants :</span> <span className={classes.inline}>(Dr P Benlian, CHRU Lille –</span> <span className={classes.inline}>Drs M Di filippo/D Collin-Chavagnac, CHU Lyon –</span> <span className={classes.inline}>Drs P Couvert/A Carrié, CHU La Pitié, Paris)</span></small>
                              </Typography>
                            </If>
                            <Typography variant={'caption'} align="right" gutterBottom={true} className={classes.caption}>
                              {
                                Q.get('profiles').map((p, i) => <div key={'p_' + i}>
                                {p.get('condition')}
                                {p.get('threshold')}: {p.get('label')}</div>).toArray()
                              }
                            </Typography>
                            <Button color="secondary" size={'large'} variant="outlined" className={classes.formSubmit} onClick={this._reset}>Recommencer</Button>

                          </If>
                        </Grid>
                        <Grid item={true} xs={12} className={classes.footer}></Grid>
                      </Grid>
                    </When>
                  </Choose>

                </div>);
              }
            }
            function mapStateToProps(state) {
              const props = {};
              return props;
            }
            function mapDispatchToProps(dispatch) {
              return {};
            }

            export default withRouter(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Home)));



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx